import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Input from "../../../../components/common/inputs/Input";
import Button from "../../../../components/common/button/Button";
import Table from "../../../../components/common/table/Table";
import { learningOutcomesColumns } from "../../../../constant/tables-columns/tablesColums";
import { learningOutcomesValidation } from "../../../../utils/validation/course/learningOutcomesValidation";
import { warningMessage } from "../../../../utils/toastify-message/ToastifyMessage";
import ImagesModal from "../../../../components/common/modals/imgaes-modal/ImagesModal";
import { publicImageProps } from "../../../../services/config";

const { forwardRef, useRef, useImperativeHandle } = React;

const LearningOutcomes = forwardRef(({ learnData, handleLearning }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {
      setLearning([]);
      setLearn(null);
    },
  }));

  console.log(learnData);

  const [learn, setLearn] = useState(null);
  const [learning, setLearning] = useState([]);

  const formHandler = async (values, { resetForm }) => {
    let isExist = learning.filter((item) => {
      return item.title == values.title;
    });
    if (!isExist.length) {
      setLearning((prev) => [...prev, { ...values, image }]);
      setLearn(null);
      resetForm();
    } else {
      warningMessage("این مورد از قبل موجود است.");
    }
  };

  const onDelete = (data) => {
    const newlearning = learning.filter((item) => item.title != data.title);
    setLearning(newlearning);
  };

  const handleNewlearning = () => {
    handleLearning(learning);
    setShowModal(false);
  };

  useEffect(() => {
    if (learnData?.length) {
      setLearning(learnData);
    }
  }, [learnData]);

  const imagesModal = useRef();
  const [image, setImage] = useState("");

  const selectedImages = (item) => {
    console.log(item);
    setImage(item.name);
  };

  return (
    <>
      <div
        className={`admin-edit-backdrop fixed top-0 right-0 w-full h-full transition-all z-30  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        hidden={!showModal}
        role="dialog"
        aria-label="نتایج یادگیری"
        aria-modal="true"
        className={`admin-edit-drawer w-full h-full overflow-y-scroll  bg-white shadow-md z-40 rounded-3xl p-4 transition-all absolute top-0 -left-[120%] ${
          showModal && "!left-0 is-open"
        }`}
      >
        <div className="flex w-full items-center justify-between">
          <h4>اضافه کردن پس از اتمام دوره</h4>
          <Button
            onClick={handleNewlearning}
            type="button"
            color="primary"
            text="بازگشت"
          />
        </div>
        <Formik
          enableReinitialize
          initialValues={{
            name: learn?.name || "",
            description: learn?.description || "",
            videoUrl: learn?.videoUrl || "",
            voiceUrl: learn?.voiceUrl || "",
          }}
          validationSchema={learningOutcomesValidation}
          onSubmit={formHandler}
        >
          {() => (
            <Form>
              <div className="grid gap-6 my-4 md:grid-cols-2">
                <Input
                  name={"name"}
                  placeholder="نام"
                  label="نام"
                  type="text"
                />
                <Input
                  name={"description"}
                  placeholder="توضیحات"
                  label="توضیحات"
                  type="text"
                />
                <Input
                  name={"videoUrl"}
                  placeholder="آدرس ویدئو"
                  label="آدرس ویدئو"
                  type="text"
                />
                <Input
                  name={"voiceUrl"}
                  placeholder="آدرس صدا"
                  label="آدرس صدا"
                  type="text"
                />

                <div className="">
                  <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                    عکس
                  </label>
                  <div className="flex items-center justify-between">
                    <div className="flex gap-2">
                      {image && (
                        <img
                          {...publicImageProps(image, { variant: "thumb_" })}
                          className="w-16 h-16 rounded-lg"
                          alt=""
                        />
                      )}
                    </div>
                    <div className="flex gap-2">
                      {image && (
                        <Button
                          type="button"
                          onClick={() => setImage("")}
                          text={"حذف"}
                          color={"danger"}
                        />
                      )}

                      <Button
                        type="button"
                        onClick={() => imagesModal.current.showModal()}
                        text={image ? "ویرایش" : "انتخاب"}
                        color={"success"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2 flex flex-wrap gap-3">
                {learn && (
                  <Button
                    type="button"
                    onClick={() => setLearn(null)}
                    text={"بازگشت"}
                    color={"danger"}
                  />
                )}
                <Button text={learn ? "ویرایش" : "افزون"} color={"primary"} />
              </div>
            </Form>
          )}
        </Formik>

        <Table
          columns={learningOutcomesColumns}
          rows={learning}
          onDelete={onDelete}
          notFoundMessage="شما هنوز هیچ چیزی اضافه نکرده اید"
        />
      </div>
      <ImagesModal selectedImages={selectedImages} ref={imagesModal} />
    </>
  );
});
export default LearningOutcomes;
